import { css, type Theme } from '@emotion/react';

const HeaderIconStyles = ({ theme }: { theme: Theme }) => css`
  fill: ${theme.colors.brand.green120};
  width: ${theme.spacing[50]};
  height: ${theme.spacing[50]};
`;

export { HeaderIconStyles };
